import essencesJson from './essences.json';
import materialsJson from './materials.json';
import otherJson from './misc.json';

const { essences } = essencesJson;
const { materials } = materialsJson;
const { other } = otherJson;

export default { essences, materials, other };
